import React, { useState } from 'react';
import api from '../api/api';

type DeliveryResult = {
  sentChats: number;
  failedChats: number;
};

type Props = {
  endpoint: string;
  label?: string;
};

export default function SendPdfToTelegramButton({ endpoint, label = '📨 Надіслати в Telegram' }: Props) {
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const send = async () => {
    setSending(true);
    setFeedback(null);
    try {
      const response = await api.post<DeliveryResult>(endpoint);
      const { sentChats, failedChats } = response.data;
      setFeedback(failedChats === 0
        ? { type: 'success', text: `Надіслано в чатів: ${sentChats}.` }
        : { type: 'error', text: `Надіслано в чатів: ${sentChats}; не вдалося: ${failedChats}.` });
    } catch (error) {
      const message = (error as { response?: { data?: { message?: string } } })?.response?.data?.message;
      setFeedback({ type: 'error', text: message || 'Не вдалося надіслати PDF у Telegram.' });
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <button
        type="button"
        onClick={send}
        disabled={sending}
        aria-busy={sending}
        style={{
          fontSize: '13px',
          padding: '7px 12px',
          borderRadius: '6px',
          border: 0,
          background: sending ? '#7f8c8d' : '#229ed9',
          color: 'white',
          cursor: sending ? 'wait' : 'pointer',
          fontWeight: 600,
        }}
      >
        {sending ? 'Надсилання…' : label}
      </button>
      {feedback && (
        <span
          role={feedback.type === 'error' ? 'alert' : 'status'}
          style={{ color: feedback.type === 'error' ? '#c0392b' : '#218c51', fontSize: '12px' }}
        >
          {feedback.text}
        </span>
      )}
    </div>
  );
}
